import axios from "axios";

const KEY = "mtg_portal_token";
export const portalToken = {
  get: () => sessionStorage.getItem(KEY),
  set: (t) => sessionStorage.setItem(KEY, t),
  clear: () => sessionStorage.removeItem(KEY),
};

const portalApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/portal` });
portalApi.interceptors.request.use((cfg) => {
  const t = portalToken.get();
  if (t) cfg.headers["X-Portal-Token"] = t;
  return cfg;
});

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
export default portalApi;
